// packages/shared-components/src/components/Sidebar/Sidebar.tsx

import React, { useState } from "react";
import "./Sidebar.css";

export interface SidebarItem {
  key: string;
  label: string;
  icon?: string;
}

export interface SidebarProps {
  items: SidebarItem[];
  activeKey: string;
  onSelect: (key: string) => void;
  collapsed?: boolean;
  onCollapsedChange?: (collapsed: boolean) => void;
  defaultCollapsed?: boolean;
}

export const Sidebar: React.FC<SidebarProps> = ({
  items,
  activeKey,
  onSelect,
  collapsed: controlledCollapsed,
  onCollapsedChange,
  defaultCollapsed = false,
}) => {
  const [internalCollapsed, setInternalCollapsed] = useState(defaultCollapsed);

  const collapsed =
    controlledCollapsed !== undefined ? controlledCollapsed : internalCollapsed;

  const handleToggleCollapse = () => {
    const newCollapsed = !collapsed;
    if (controlledCollapsed === undefined) {
      setInternalCollapsed(newCollapsed);
    }
    onCollapsedChange?.(newCollapsed);
  };

  return (
    <div
      className={`shared-sidebar ${
        collapsed ? "shared-sidebar-collapsed" : ""
      }`}
    >
      <div className="shared-sidebar-header">
        {!collapsed && <span className="shared-sidebar-title">组件展示</span>}
        <button
          className="shared-sidebar-toggle"
          onClick={handleToggleCollapse}
          title={collapsed ? "展开" : "收起"}
        >
          {collapsed ? "→" : "←"}
        </button>
      </div>

      <nav className="shared-sidebar-nav">
        {items.map((item) => (
          <button
            key={item.key}
            className={`shared-sidebar-item ${
              activeKey === item.key ? "shared-sidebar-item-active" : ""
            }`}
            onClick={() => onSelect(item.key)}
            title={collapsed ? item.label : undefined}
          >
            {item.icon && (
              <span className="shared-sidebar-icon">{item.icon}</span>
            )}
            {!collapsed && (
              <span className="shared-sidebar-label">{item.label}</span>
            )}
          </button>
        ))}
      </nav>
    </div>
  );
};
